import { Info, List } from "template/ListTemplate.style";
import migrationColumn from "../../migrationColumn.json";
import { costFormat } from "components/costForamt";

// 브릿지 -> 스왑 :: 요약 낱개 (http://localhost:3000/super/bridge/migration)
const MigrationSummaryList = ({ data }) => {
  return (
    <Info.Content>
      {/* 총 스왑 금액 */}
      <List.Row $ratio={migrationColumn.summary[0].ratio}>
        {costFormat(data?.totalAmount)}
      </List.Row>

      {/* 총 스왑 신청 금액 */}
      <List.Row $ratio={migrationColumn.summary[1].ratio}>
        {costFormat(data?.reqAmount)}
      </List.Row>

      {/* 총 스왑 수수료 */}
      <List.Row $ratio={migrationColumn.summary[2].ratio}>
        {costFormat(data?.feeAmount)}
      </List.Row>

      {/* 총 개수 */}
      <List.Row $ratio={migrationColumn.summary[3].ratio}>
        {costFormat(data?.cnt)}
      </List.Row>

      {/* 성공 개수 */}
      <List.Row $ratio={migrationColumn.summary[3].ratio}>
        {costFormat(data?.successCnt)}
      </List.Row>

      {/* 나머지 개수 */}
      <List.Row $ratio={migrationColumn.summary[3].ratio}>
        {costFormat(data?.failCnt)}
      </List.Row>
    </Info.Content>
  );
};

export default MigrationSummaryList;
